export default __webpack_public_path__ + "static/productIcon2-893336f943fabc69dcb42502e38bda41.svg";